// ─── Auth helpers ─────────────────────────────────────────────────────────────

export function getToken() {
  return localStorage.getItem("token");
}

export function authHeaders() {
  return { Authorization: `Bearer ${getToken()}` };
}